import React from 'react';

// MUI
import Calendar from '@mui/icons-material/Event';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';

import { styled } from '@mui/material/styles';

export const StyledPicker = styled((props) => <DateRangePicker {...props} />)(
  ({ theme, noSeparator }) => ({
    ...(noSeparator && {
      gap: '0 0.5rem',
      '.MuiFormControl-root': {
        marginLeft: 0,
      },
    }),
  })
);

const Index = ({
  callback,
  disabled,
  startLabel = 'Start Date',
  endLabel = 'End Date',
  noSeparator,
  ...rest
}) => {
  const dateProps = {
    disabled,
    localeText: {
      start: startLabel,
      end: endLabel,
    },
    slotProps: {
      fieldSeparator: { sx: { display: noSeparator && 'none' } },
      textField: {
        InputProps: { endAdornment: <Calendar /> },
      },
    },
    onChange: (value) => callback(value),
  };

  const dateRangePickerProps = {
    noSeparator,
    ...dateProps,
    ...rest,
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <StyledPicker {...dateRangePickerProps} />
    </LocalizationProvider>
  );
};

export default Index;
